export const tracerouteAddress = /^(.*)\s+\[([^\]]+)\]$/;

export const ipv4Regex = /^(?:(?:25[0-5]|2[0-4]\d|1?\d{1,2})(?:\.(?!$)|$)){4}$/;

export const ipv6Regex =
  /^((([0-9A-Fa-f]{1,4}:){1,6}:)|(([0-9A-Fa-f]{1,4}:){7}))([0-9A-Fa-f]{1,4})$/;

export const ipExtractionRegex =
  /(?:^|\s|[([])((\d{1,3}\.){3}\d{1,3})(?:\s|[)\]]|$)/;
